export default "__VITE_ASSET__DWSMUE3J__"